import { Injectable } from '@angular/core';
import { Subject } from "rxjs";
@Injectable({
  providedIn: 'root'
})
export class ValidatorPasswordService {
  status= new Subject();
  constructor() { }
  onKey(value){
    this.status.next(value);
  }
}